import { render, staticRenderFns } from "./FormTemplatePageBreak.vue?vue&type=template&id=94a72548&scoped=true&"
import script from "./FormTemplatePageBreak.vue?vue&type=script&lang=js&"
export * from "./FormTemplatePageBreak.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplatePageBreak.vue?vue&type=style&index=0&id=94a72548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a72548",
  null
  
)

export default component.exports